import {
  ImageHelper,
  type IProductModel,
  type ITextComponentWithAssetsModel,
} from "@nf/common";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";

import LandingPageHeroSection from "components/LandingPage/LandingPageHeroSection";
import LandingPageBrand from "components/LandingPage/LandingPageBrand";
import { useFeature } from "hooks";

import { LANDING_PAGE_COMPONENT_SUB_TYPE } from "@nf/common/src/providers/DataProvider/RedBeeMedia/constants";
import type { ILandingPageHeroComponent } from "../types";

import styles from "./LandingPageHero.module.scss";

const LandingPageOffers = dynamic(
  () => import("components/LandingPage/LandingPageOffers")
);

interface LandingPageHeroProps {
  component: ITextComponentWithAssetsModel;
  offers?: IProductModel[];
}

const LandingPageHero = ({ component, offers }: LandingPageHeroProps) => {
  const { t } = useTranslation("translations");
  const { sub_type } =
    component.TextParsed as unknown as ILandingPageHeroComponent;

  /* TODO remove once anniversary campaign is over */
  const isAnniversaryCampaignActive = useFeature("anniversaryCampaign");

  const backgroundImage = ImageHelper.getHighlightsImageUrl(
    component.MediaList?.[0]?.Images,
    null
  );

  return (
    <div className={styles.container}>
      <LandingPageHeroSection image={backgroundImage}>
        {/* TODO remove once anniversary campaign is over */}
        <div className={styles.content}>
          <LandingPageBrand>
            {t("web_landing_page_hero_headline")}
          </LandingPageBrand>

          {/* TODO remove once anniversary campaign is over */}
          {isAnniversaryCampaignActive && (
            <p className={styles.subtitle}>
              {t("web_landing_page_hero_sub_headline_denmark")}
            </p>
          )}
        </div>

        {sub_type === LANDING_PAGE_COMPONENT_SUB_TYPE.OFFERS && offers && (
          <LandingPageOffers offers={offers} />
        )}
      </LandingPageHeroSection>
    </div>
  );
};

export default LandingPageHero;
